import { loader } from 'graphql.macro'

export default function clientQuery ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const clientSchema = loader('./client.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(clientSchema, { id })
}
